import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRight, Star, Zap } from 'lucide-react';

export const PromoCard = ({
    title,
    description,
    label,
    link,
    gradient,
    icon: Icon = Star,
    tag,
    isExternal,
    delay,
    ctaText = "Read More"
}) => {

    const Wrapper = isExternal ? 'a' : Link;
    const props = isExternal ? { href: link, target: '_blank', rel: 'noopener noreferrer' } : { to: link };

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: delay }}
            className="h-full"
        >
            <Wrapper {...props} className="flex flex-col h-full relative group overflow-hidden rounded-xl shadow-lg border border-white/10 transition-all hover:shadow-2xl hover:-translate-y-1">
                {/* Background Gradient */}
                <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-90 transition-all duration-500 group-hover:scale-105 group-hover:opacity-100`} />

                {/* Shine Effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-shine" />

                <div className="relative z-10 p-6 flex flex-col h-full text-white">
                    {/* Header: Tag + Label */}
                    <div className="flex items-center justify-between mb-4">
                        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-black/20 backdrop-blur-md border border-white/10 text-xs font-bold uppercase tracking-wider shadow-sm">
                            {Icon && <Icon className="w-3.5 h-3.5" />}
                            {label}
                        </span>
                        {tag && (
                            <span className="flex items-center gap-1 text-[10px] font-bold bg-white/20 px-2 py-0.5 rounded-md shadow-sm backdrop-blur-sm">
                                <Zap className="w-3 h-3 text-yellow-300 fill-yellow-300" />
                                {tag}
                            </span>
                        )}
                    </div>

                    {/* Content */}
                    <div className="flex-1">
                        {/* Large Icon if needed, or just Title? User asked for Icon then Title */}
                        <h3 className="text-2xl font-bold leading-tight mb-3 drop-shadow-sm group-hover:drop-shadow-md transition-all">
                            {title}
                        </h3>
                        {description && (
                            <p className="text-sm text-white/90 leading-relaxed font-medium opacity-90 mb-4 line-clamp-3">
                                {description}
                            </p>
                        )}
                    </div>

                    {/* CTA Layout */}
                    <div className="mt-auto pt-4">
                        <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-black font-bold rounded-full text-sm hover:bg-white/90 transition-all shadow-lg group-hover:gap-3 group-hover:scale-105 transform origin-left">
                            {ctaText}
                            <ChevronRight className="w-4 h-4" />
                        </div>
                    </div>
                </div>
            </Wrapper>
        </motion.div>
    );
};
